/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReturnFromCoupangConfirmReceiveAddressVo } from './ReturnFromCoupangConfirmReceiveAddressVo';
import {
    ReturnFromCoupangConfirmReceiveAddressVoFromJSON,
    ReturnFromCoupangConfirmReceiveAddressVoFromJSONTyped,
    ReturnFromCoupangConfirmReceiveAddressVoToJSON,
    ReturnFromCoupangConfirmReceiveAddressVoToJSONTyped,
} from './ReturnFromCoupangConfirmReceiveAddressVo';

/**
 * 
 * @export
 * @interface ReturnFromCoupangApplyProcessReqVo
 */
export interface ReturnFromCoupangApplyProcessReqVo {
    /**
     * 确认请求状态的订单批量申请处理；单订单仅流转状态，多订单按现有合单规则合并为一个新订单。
     * 申请处理的订单ID列表，全部必须为确认请求状态
     * @type {Array<number>}
     * @memberof ReturnFromCoupangApplyProcessReqVo
     */
    orderIds?: Array<number>;
    /**
     * 本次申请的返送处理方式：1废弃，2韩国库存，3韩国快递，4橙火入仓一般快递，5橙火入仓官方揽收快递，6橙火入仓官方揽收托盘，不允许待定
     * @type {number}
     * @memberof ReturnFromCoupangApplyProcessReqVo
     */
    returnProcessMethod?: number;
    /**
     * 
     * @type {ReturnFromCoupangConfirmReceiveAddressVo}
     * @memberof ReturnFromCoupangApplyProcessReqVo
     */
    returnFromCoupangConfirmReceiveAddressVO?: ReturnFromCoupangConfirmReceiveAddressVo;
}

/**
 * Check if a given object implements the ReturnFromCoupangApplyProcessReqVo interface.
 */
export function instanceOfReturnFromCoupangApplyProcessReqVo(value: object): value is ReturnFromCoupangApplyProcessReqVo {
    return true;
}

export function ReturnFromCoupangApplyProcessReqVoFromJSON(json: any): ReturnFromCoupangApplyProcessReqVo {
    return ReturnFromCoupangApplyProcessReqVoFromJSONTyped(json, false);
}

export function ReturnFromCoupangApplyProcessReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReturnFromCoupangApplyProcessReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderIds': json['orderIds'] == null ? undefined : json['orderIds'],
        'returnProcessMethod': json['returnProcessMethod'] == null ? undefined : json['returnProcessMethod'],
        'returnFromCoupangConfirmReceiveAddressVO': json['returnFromCoupangConfirmReceiveAddressVO'] == null ? undefined : ReturnFromCoupangConfirmReceiveAddressVoFromJSON(json['returnFromCoupangConfirmReceiveAddressVO']),
    };
}

export function ReturnFromCoupangApplyProcessReqVoToJSON(json: any): ReturnFromCoupangApplyProcessReqVo {
    return ReturnFromCoupangApplyProcessReqVoToJSONTyped(json, false);
}

export function ReturnFromCoupangApplyProcessReqVoToJSONTyped(value?: ReturnFromCoupangApplyProcessReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderIds': value['orderIds'],
        'returnProcessMethod': value['returnProcessMethod'],
        'returnFromCoupangConfirmReceiveAddressVO': ReturnFromCoupangConfirmReceiveAddressVoToJSON(value['returnFromCoupangConfirmReceiveAddressVO']),
    };
}

